import XbuttonBusiness from "graphics/icons/XbuttonBusiness";
import React from "react";
import { useDispatch } from "react-redux";
import {
  setSpaceSidebar,
  SPACE_CHAT,
  SPACE_PEOPLE,
} from "slices/spaceMediaSlice";
import SpaceMcht from "./SpaceMcht/SpaceMcht";
import SpacePeople from "./SpacePeople/SpacePeople";

const SpaceSideBar = ({ spaceSideBar }) => {
  const dispatch = useDispatch();

  return (
    <div className="spaceSideBar">
      <div className={`my-modal-header business-text`}>
        <span className={`spaceSidebar-tab`}>
          {spaceSideBar === SPACE_PEOPLE
            ? "People"
            : spaceSideBar === SPACE_CHAT
            ? "Live Chat"
            : null}
        </span>
        <div
          className="modal-exit"
          onClick={() => dispatch(setSpaceSidebar(null))}
        >
          <XbuttonBusiness />
        </div>
      </div>
      {spaceSideBar === SPACE_PEOPLE ? (
        <SpacePeople />
      ) : spaceSideBar === SPACE_CHAT ? (
        <SpaceMcht />
      ) : null}
    </div>
  );
};

export default SpaceSideBar;
